import { render, staticRenderFns } from "./RealizedGainLossList.vue?vue&type=template&id=385e49ec&scoped=true&"
import script from "./RealizedGainLossList.vue?vue&type=script&lang=js&"
export * from "./RealizedGainLossList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385e49ec",
  null
  
)

export default component.exports